export default {
  checkbox: {
    appliesTo: 'all',
    dataType: 'BOOLEAN',
    defaultValue: false,
    defaultVisible: false,
    description: 'Boolean type',
    enabled: true,
    fieldType: 'CHECKBOX',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'checkbox',
    options: 'false,true',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 12,
    title: 'Checkbox',
  },
  date: {
    appliesTo: 'all',
    dataType: 'DATE',
    defaultVisible: false,
    description: 'Date type',
    enabled: true,
    fieldType: 'DATE',
    filterable: false,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'date',
    required: true,
    searchable: true,
    solrFieldTypeVal: 'date',
    sortOrder: 1,
    title: 'Date',
  },
  hidden: {
    hidden: true,
    title: 'Hidden (should not be displayed!)',
  },
  number: {
    appliesTo: 'all',
    dataType: 'NUMBER',
    defaultVisible: false,
    description: 'Number type',
    enabled: true,
    fieldType: 'TEXT',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'number',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'double',
    sortOrder: 22,
    title: 'Number',
  },
  password: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Password type',
    enabled: true,
    fieldType: 'PASSWORD',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'password',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 10,
    title: 'Password',
  },
  select: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultValue: 'Option 1',
    defaultVisible: false,
    description: 'Option type',
    enabled: true,
    fieldType: 'SELECT',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'select',
    options: 'Option 1, Option 2, Option 3,Option 4',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 2,
    title: 'Select',
  },
  text: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'String type',
    enabled: true,
    fieldType: 'TEXT',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'text',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 4,
    title: 'Text',
  },
  textarea: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'Textarea type',
    enabled: true,
    fieldType: 'TEXTAREA',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: false,
    name: 'textarea',
    required: false,
    searchable: true,
    solrFieldTypeVal: 'textarea',
    sortOrder: 5,
    title: 'Textarea',
  },
  title: {
    appliesTo: 'all',
    dataType: 'STRING',
    defaultVisible: false,
    description: 'The title of the asset',
    enabled: true,
    fieldType: 'TEXT',
    filterable: true,
    hidden: false,
    isProtected: false,
    multilingual: true,
    name: 'title',
    required: true,
    searchable: true,
    solrFieldTypeVal: 'text',
    sortOrder: 0,
    title: 'Title',
  },
};
